module.exports = __webpack_public_path__ + "img/highes-int-back.6e14aa69.svg";